import { Trans, useLingui } from "@lingui/react/macro";
import { Outlet, useMatch, useNavigate } from "react-router";
import {
  BackButton,
  CloseButton,
} from "@/components/NavigationButtons/NavigationButtons";
import styles from "./NewShift.module.scss";
import { Heading } from "@medoma/components/Heading/Heading";
import { Tab, TabList, TabPanel, Tabs } from "@medoma/components/Tabs";
import { Loading } from "@medoma/components/Loading/Loading";
import { useShiftPresets } from "@/api/Shifts";
import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";
import { deducedError } from "@/Utils/ErrorUtils";
import * as Sentry from "@sentry/react";
import NewCustomShiftForm from "@/forms/NewCustomShiftForm";

const NewShiftContent = () => {
  const { data: shiftTemplates, isPending, isError, error } = useShiftPresets();
  const { t } = useLingui();

  if (isPending) {
    return <Loading message={t`Hämtar information om nya arbetspass`} />;
  }

  if (isError) {
    Sentry.captureException(error);
    return (
      <ErrorMessage
        message={`${t`Kunde inte hämta information om nya arbetspass`}. ${deducedError(error)}`}
      />
    );
  }

  if (shiftTemplates.length === 0) {
    return <NewCustomShiftForm />;
  }

  return (
    <Tabs>
      <TabList>
        <Tab to="templates">
          <Trans>Mallar</Trans>
        </Tab>
        <Tab to="custom">
          <Trans>Anpassat</Trans>
        </Tab>
      </TabList>
      <div className={styles.tabPanel}>
        <TabPanel>
          <Outlet />
        </TabPanel>
      </div>
    </Tabs>
  );
};

const NewShift = () => {
  const navigate = useNavigate();
  const { t } = useLingui();
  const isNewShiftFromTemplateRoute = useMatch(
    "/commandcenter/shifts/new/templates/:templateId",
  );

  return (
    <article className={styles.newShift}>
      <div className={styles.header}>
        {isNewShiftFromTemplateRoute ? (
          <BackButton
            navigateBack={() => navigate("templates")}
            ariaLabel={t`Tillbaka till mallar`}
          />
        ) : null}
        <Heading level="h1">
          <Trans>Skapa arbetspass</Trans>
        </Heading>
        <div className={styles.closeButton}>
          <CloseButton close={() => navigate("..")} />
        </div>
      </div>
      <NewShiftContent />
    </article>
  );
};

export default NewShift;
